module.exports = __webpack_public_path__ + "icon_goal-aa2a22a0432ae4a25eb174457cce860a.png";